import { makeAnchorEmitter } from "../components/ReusableFunctions";
import { LineCommented } from "../components/ReusableFunctions";
export const PeToolsStyles = {
    CaptionPunctuation: {
        name: "Caption Punctuation",
        description: "Ensures captions end with a full stop (placed before any trailing label).",
        markerClass: "ace-Common-highlight",

        execute(texFile, session, Range, anchorlist, filename, Allfiles, existingSuggestions = [], rejectedSuggestions = []) {
            const staleIds = new Set();
            const emit = makeAnchorEmitter({
                texFile, session, Range, anchorlist, existingSuggestions, staleIds, styleName: this.name,
                markerClass: this.markerClass,
            });

            const captionPattern = /\\caption\s*\{/gi;
            let match;

            while ((match = captionPattern.exec(texFile)) !== null) {
                if (LineCommented(texFile, match.index)) continue;

                // 1. Extract balanced content of \caption{...}
                let depth = 1, i = match.index + match[0].length, content = '';
                while (i < texFile.length && depth > 0) {
                    if (texFile[i] === '\\') { content += texFile[i] + (texFile[i + 1] || ''); i += 2; continue; }
                    if (texFile[i] === '{') depth++;
                    else if (texFile[i] === '}') {
                        depth--;
                        if (depth === 0) break;
                    }
                    content += texFile[i];
                    i++;
                }

                const fullMatch = texFile.slice(match.index, i + 1);
                const trimmedContent = content.trim();

                if (!trimmedContent) continue;

                // 2. Identify trailing labels: \caption{Text \label{fig:1}}
                // We want to put the period before the label if the label is at the very end.
                const labelPattern = /\\label\s*\{[^}]+\}\s*$/i;
                const hasTrailingLabel = labelPattern.test(trimmedContent);

                let suggestionContent = '';

                if (hasTrailingLabel) {
                    // Split text and label: "Some text \label{key}" -> ["Some text ", "\label{key}"]
                    const labelMatch = trimmedContent.match(labelPattern)[0];
                    const textBeforeLabel = trimmedContent.slice(0, trimmedContent.length - labelMatch.length).trim();

                    // If text before label doesn't end in punctuation, add a period
                    if (textBeforeLabel && !/[.\!\?]$/.test(textBeforeLabel)) {
                        suggestionContent = `${textBeforeLabel}. ${labelMatch}`;
                    }
                } else {
                    // No trailing label, just check the end of the string
                    if (!/[.\!\?]$/.test(trimmedContent)) {
                        suggestionContent = `${trimmedContent}.`;
                    }
                }

                // 3. Emit if a change is needed
                if (suggestionContent) {
                    const suggestion = `${match[0]}${suggestionContent}}`;

                    emit(
                        fullMatch,
                        suggestion,
                        match.index,
                        this.description
                    );
                }
            }

            return staleIds;
        }
    }
};